import fetch from '../utils/fetch';


export function menuTree(params) {
  return fetch({
    method: 'GET',
    url: '/menu/menuTree',
    params
  })
}



export function menuadd(params) {
  return fetch({
    method: 'POST',
    url: '/menu/add',
    data:params
  })
}


export function menumodify(params) {
  return fetch({
    method: 'POST',
    url: '/menu/modify',
    data:params
  })
}
